// extracted by mini-css-extract-plugin
export var bounce = "styles-module--bounce--c7aed";
export var card = "styles-module--card--571a0";
export var pulse = "styles-module--pulse--c1608";